var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.4737 0C14.5414 0 13.786 0.895736 13.786 2C13.786 3.10426 14.5414 4 15.4737 4H39.0983C40.0301 4 40.786 3.10426 40.786 2C40.786 0.895736 40.0302 0 39.0983 0H15.4737Z",
    fill: "#628BF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.78601 9.00027C6.78601 7.89536 7.53209 7 8.4524 7H45.1192C46.0399 7 46.786 7.89533 46.786 9.00027C46.786 10.1047 46.0399 11 45.1192 11H8.4524C7.53211 11 6.78601 10.1047 6.78601 9.00027Z",
    fill: "#628BF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40386 13.9131C3.76252 13.9131 0 17.6761 0 22.3174V39.1249C0 43.7662 3.76252 47.5287 8.40386 47.5287H45.3817C50.023 47.5287 53.786 43.7662 53.786 39.1249V22.3174C53.786 17.6761 50.023 13.9131 45.3817 13.9131H8.40386Z",
    fill: "#628BF3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.716b2ac51431667018fa47421b703f92.svg";
export { ForwardRef as ReactComponent };